import { toPersianDigits } from "./persianDigits";

// Converts bracket-style footnote markers ("[1]", "[۲]") sitting in plain
// text into small superscript reference numbers — <sup class="footnote-ref">
// — matching how print magazines mark the word a footnote belongs to, and
// normalizes the digits (whether the admin typed Western or Persian ones)
// to Persian numerals. Used both by RichText.js (so every already-
// published article renders this way immediately, no re-editing needed)
// and, before that existed, by RichTextEditor.js's paste/input rules for
// newly typed content — which is why already-marked <sup>s also get their
// digits normalized here, not just plain "[1]" text.
const FOOTNOTE_REF_PATTERN = /\[([0-9۰-۹]+)\]/g;

export function wrapFootnoteRefs(html) {
  if (!html || (!html.includes("[") && !html.includes("footnote-ref"))) return html;

  const doc = new DOMParser().parseFromString(html, "text/html");

  doc.querySelectorAll("sup.footnote-ref").forEach((sup) => {
    sup.textContent = toPersianDigits(sup.textContent);
  });

  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node = walker.nextNode();
  while (node) {
    FOOTNOTE_REF_PATTERN.lastIndex = 0;
    if (!(node.parentElement && node.parentElement.closest("sup.footnote-ref")) && FOOTNOTE_REF_PATTERN.test(node.textContent)) {
      textNodes.push(node);
    }
    node = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    const text = textNode.textContent;
    const frag = doc.createDocumentFragment();
    let lastIndex = 0;
    FOOTNOTE_REF_PATTERN.lastIndex = 0;
    let match = FOOTNOTE_REF_PATTERN.exec(text);
    while (match) {
      if (match.index > lastIndex) {
        frag.appendChild(doc.createTextNode(text.slice(lastIndex, match.index)));
      }
      const sup = doc.createElement("sup");
      sup.className = "footnote-ref";
      sup.textContent = toPersianDigits(match[1]);
      frag.appendChild(sup);
      lastIndex = match.index + match[0].length;
      match = FOOTNOTE_REF_PATTERN.exec(text);
    }
    if (lastIndex < text.length) {
      frag.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }
    textNode.replaceWith(frag);
  });

  return doc.body.innerHTML;
}
